import { CSSProperties } from 'react';
import { WorkspaceModelNode } from './WorkspaceModelNode';
import { WorkspaceModelBrowserWrapper } from './atoms';
import { TreeSvg } from './TreeSvg';
import { ArdoqId, ComponentTypeHierarchy } from '@ardoq/api-types';
import { connect } from '@ardoq/rxbeach';
import { combineLatest } from 'rxjs';
import { i18nLocale$ } from 'streams/i18nLocale$';
import { t, type WithI18nLocale } from '@ardoq/i18n';

type WorkspaceModelBrowserProps = {
  root: ComponentTypeHierarchy;
  highlightedComponentTypeId?: ArdoqId;
  style?: CSSProperties;
};

type WorkspaceModelBrowserConnectedProps = WorkspaceModelBrowserProps &
  WithI18nLocale;

const getComponentTypes = (root: ComponentTypeHierarchy) => Object.values(root);

const WorkspaceModelBrowserBase = ({
  highlightedComponentTypeId,
  root = {},
  style,
  i18nLocale,
}: WorkspaceModelBrowserConnectedProps) => {
  const componentTypes = getComponentTypes(root);
  return (
    <WorkspaceModelBrowserWrapper
      role="list"
      aria-label={t(
        i18nLocale,
        'workspaceModelBrowser:ariaLabel',
        'Metamodel preview'
      )}
      data-test-id="metamodel-preview"
      style={style}
    >
      {componentTypes.map(componentType => (
        <WorkspaceModelNode
          key={componentType.id}
          componentType={componentType}
          highlightedComponentTypeId={highlightedComponentTypeId}
        />
      ))}
      <TreeSvg componentTypes={componentTypes} />
    </WorkspaceModelBrowserWrapper>
  );
};

export const WorkspaceModelBrowser = connect(
  WorkspaceModelBrowserBase,
  combineLatest({ i18nLocale: i18nLocale$ })
);
